module.exports = __webpack_public_path__ + "0a7707e1c38d050b07b58e4b7e7c6867.pdf";